import { AdditionalInfo } from './../account/additional-information/getAdditionalInformationResponse';
export enum Gender {
  Male = 1,
  Female = 2,
  Other = 3
}

// Mapping of enum values to their descriptions
export const GenderDescriptions: { [key in Gender]: string } = {
  [Gender.Male]: "Male",
  [Gender.Female]: "Female",
  [Gender.Other]: "Other"
};


export enum AuthRoles {
  Student = 1,
  Mentor = 2,
  Admin = 3,
  SuperAdmin = 4,
  PeerReviewer = 5,
  SchoolAdmin = 6,
  Operations = 7
}

// Mapping of enum values to their descriptions
export const AuthRolesDescriptions: { [key in AuthRoles]: string } = {
  [AuthRoles.Student]: "Student",
  [AuthRoles.Mentor]: "Mentor",
  [AuthRoles.Admin]: "Admin",
  [AuthRoles.SuperAdmin]: "SuperAdmin",
  [AuthRoles.PeerReviewer]: "PeerReviewer",
  [AuthRoles.SchoolAdmin]: "SchoolAdmin",
  [AuthRoles.Operations]: "Operations",
};

// Reverse mapping: string -> AuthRoles
export const AuthRolesFromString: { [key: string]: AuthRoles } = {
  Student: AuthRoles.Student,
  Mentor: AuthRoles.Mentor,
  Admin: AuthRoles.Admin,
  SuperAdmin: AuthRoles.SuperAdmin,
  PeerReviewer: AuthRoles.PeerReviewer,
  SchoolAdmin: AuthRoles.SchoolAdmin,
  Operations: AuthRoles.Operations,
};


export enum MentorType {
  Mentor = 1,
  PeerReviewer = 2
}

// Mapping of enum values to their descriptions
export const MentorTypeDescriptions: { [key in MentorType]: string } = {
  [MentorType.Mentor]: "Mentor",
  [MentorType.PeerReviewer]: "PeerReviewer"
};

export enum Course {
  Bachelors = 0,
  Masters = 1,
  CertificationCourse = 2,
  Phd = 3,
  None = 4
}

export enum CityType
{
    City=0,
    Suburb=1,
    Town=2
}
export enum CitySize
{
    Remote,
    Small,
    Large,
    Distant,
    Midsize,
    Fringe

}
export const CitySizeDescriptions: { [key in CitySize|any]: string} = {
  [CitySize.Remote]: "Remote",
  [CitySize.Small]: "Small",
  [CitySize.Large]: "Large",
  [CitySize.Distant]: "Distant",
  [CitySize.Midsize]: "Midsize",
  [CitySize.Fringe]: "Fringe",
}


// Mapping of enum values to their descriptions
export const CityTypeDescriptions: { [key in CityType|any]: string } = {
  [CityType.City]: "City",
  [CityType.Suburb]: "Suburb",
  [CityType.Town]: "Town"
};


export enum MessageTemplate
{
  TaskAssigned,
  TaskCompleted,
  EssaySubmission,
  RecommendationSubmission,
  ActivitySubmission,
  MentorReview,
  MeetingScheduled,
  MeetingCanceled,
  MeetingRescheduled,
  AddedMyInstitute,
  MindlerNotification,
  DocumentRequested,
  DocumentUploaded
};

export enum ProfileSection{
  Profile = 'Profile',
  CheckList = 'CheckList',
  Documents = 'Documents',
  EssayPilot = 'EssayPilot',
  General = 'General',
  Colleges = 'Colleges'
};

export enum MentorState {
  Unknown,
  Active,
  Inactive
}

export const MentorStateDescriptions: { [key in MentorState|any]: string } = {
  [MentorState.Unknown]: "Pending",
  [MentorState.Active]: "Approved",
  [MentorState.Inactive]: "Rejected"
};

export enum MeetingState {
  Active=1,
  Canceled=2,
  Rescheduled = 3
}

export const MeetingStateDescriptions: { [key in MeetingState|any]: string } = {
  [MeetingState.Active]: "Active",
  [MeetingState.Canceled]: "Canceled",
  [MeetingState.Rescheduled]: "Rescheduled",
};

export enum AssessmentType
{
  None,
  Stream,
  Career
}
export const AssessmentTypeDescriptions: { [key in AssessmentType|any]: string } = {
  [AssessmentType.None]: "None",
  [AssessmentType.Stream]: "Stream",
  [AssessmentType.Career]: "Career"
}


export enum TestType{
  stream=1,
  career=2
}
